module.exports = __webpack_public_path__ + "img/stamp-insect-sep.094530c8.png";